import React from "react";
import { Routes, Route } from "react-router-dom";
import DashboardLayout from "../components/DashboardLayout";
import Login from "../pages/Login";
import Dashboard from "../pages/Dashboard";
import Department from "../pages/Department";
import ReportPage from "../pages/ReportPage";
import StaffManagement from "../pages/StaffManagement";
import Ticket from "../pages/Ticket";
import ViewTicket from "../pages/ViewTicket";
import ProtectedRoute from "./ProtectedRoute";
import ErrorPage from "../components/common/ErrorPage";
import Client from "../pages/Client";
import Vendor from "../pages/Vendor";
import Category from "../pages/Category";
import VendorRegistrationForm from "../pages/VendorRegistrationForm";
import RegisteredVendors from "../pages/RegisteredVendors";
import VendorTab from "../pages/VendorTab";
import VendorRegistrationEditForm from "../pages/VendorRegistrationFormEdit";
import VendorEventRegistrationForm from "../pages/VendorEventRegistrationForm";
import DailyCateringOrderForm from "../pages/DailyCateringOrderForm";
import DailyCateringOrderReport from "../pages/DailyCateringOrderReport";

const Roots = () => {
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="*" element={<ErrorPage />} />
      <Route path="vendor-registration" element={<VendorRegistrationForm />} />
      <Route
        path="daily-catering-order-form"
        element={<DailyCateringOrderForm />}
      />
      <Route
        path="daily-catering-order-report"
        element={<DailyCateringOrderReport />}
      />
      <Route
        path="vendor-event-registration/:vendorId"
        element={<VendorEventRegistrationForm />}
      />
      <Route
        path="vendor-event-registration/"
        element={<VendorEventRegistrationForm />}
      />
      <Route
        path="vendor-registration-update/:vendorId"
        element={<VendorRegistrationEditForm />}
      />
      <Route element={<ProtectedRoute />}>
        <Route path="/" element={<DashboardLayout />}>
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="department" element={<Department />} />
          <Route path="reports" element={<ReportPage />} />
          <Route path="client" element={<Client />} />
          <Route path="category" element={<Category />} />
          <Route path="vendor" element={<VendorTab />} />
          <Route path="RegisteredVendors" element={<RegisteredVendors />} />
          <Route path="staff" element={<StaffManagement userType="Admin" />} />
          <Route path="user" element={<StaffManagement userType="user" />} />

          <Route path="tickets" element={<Ticket />} />
          <Route path="viewticket/:ticketId" element={<ViewTicket />} />
        </Route>
      </Route>
    </Routes>
  );
};

export default Roots;
